import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TenantsMgmtComponent} from './tenants-mgmt.component';
import {TenantsMgmtRoutingModule} from 'src/app/main/tenants-mgmt/tenants-mgmt-routing.module';
import {BreadcrumbModule} from '../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from 'src/app/shared/shared.module';
import { CreateTenantNewComponent } from './create-tenant-new/create-tenant-new.component';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { ErrorModule } from 'src/app/components/error/error.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatSelectModule } from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DatepickerModule } from 'src/app/components/datepicker/datepicker.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    TenantsMgmtComponent,
    CreateTenantNewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    TenantsMgmtRoutingModule,
    ToolbarModule,
    ErrorModule,
    IconsModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    DatepickerModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    PipesModule,
    MatMenuModule,
  ]
})
export class TenantsMgmtModule {
}
